export default __webpack_public_path__ + "static/steg-fc95e117a40ba96e7a4e90dee6eccfbe.jpg";